// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.step-indicator {
  width: 80%;
  margin-left: 10%;
}

.main-div {
  margin-left: 12.25%;
  margin-right: 12.25%;
  margin-top: 20px;
  margin-bottom: 20px;
}

@media (max-width: 500px) {
  .main-div {
    width: 335px;
    margin-left: 10px;
  }
}
.review-heading {
  font-size: 32px;
  color: #000000;
  opacity: 1;
  float: left;
}
@media (max-width: 1024px) {
  .review-heading {
    font-size: 24px;
  }
}

.review-info {
  width: 100%;
  float: left;
  margin-top: 2%;
  margin-bottom: 2%;
}
@media (max-width: 1024px) {
  .review-info {
    width: 340px !important;
  }
}
@media only screen and (max-width: 1020px) and (min-width: 500px) {
  .review-info {
    width: 660px !important;
  }
}

.review-blocks {
  display: inline-block;
  margin-right: 10%;
}
@media (max-width: 1024px) {
  .review-blocks {
    margin-right: 23px;
    width: 90px;
  }
}

.review-block-heading {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  text-align: left;
  display: inline-block;
  width: 500px;
}
@media (max-width: 1024px) {
  .review-block-heading {
    width: 325px;
    word-break: break-word;
  }
}

.review-block-value {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .review-block-value {
    width: 95px;
    font-size: 16px;
  }
}

#cancel-link {
  float: right;
  margin-right: 20px;
  margin-top: 15px;
  font-size: 18px;
}

#submitGrp {
  float: right;
}

.submit-section {
  height: 50px;
}

#button-section {
  margin-bottom: 36px;
  margin-top: 36px;
}

.changeLink {
  float: right;
  margin-right: 243px;
}
@media (max-width: 1024px) {
  .changeLink {
    margin-right: 0px;
  }
}

#viewDevices {
  margin-top: 24px;
  width: 100%;
  display: inline-block;
}

.continue-btn {
  width: 171px;
  margin-left: 19px;
}

.color-square {
  border-radius: 2px;
  display: inline-block;
  height: 14px;
  margin-right: 10px;
  vertical-align: middle;
  width: 14px;
}

.custumgrid-field {
  display: inline-block;
  vertical-align: middle;
}

.gridText {
  display: inline-flex;
}

.custumgrid-field-status {
  vertical-align: super;
  line-height: 16px;
}

.claimed-samsung {
  background-color: #035527;
}

.enrolled-active {
  background-color: #1483D9;
}

.enrolled-not-active {
  background-color: #B9D5E8;
}

.not-enrolled {
  background-color: #e97400;
}

.out-of-compliance {
  background-color: #cccccc;
}

.claimed-samsung {
  background-color: #035527;
}

.claimed-android™ {
  background-color: #035527;
}

.claimed-android {
  background-color: #035527;
}

.claimed-apple {
  background-color: #035527;
}

.claim-pending-samsung {
  background-color: #6BA179;
}

.claim-pending-android™ {
  background-color: #6BA179;
}

.claim-pending-android {
  background-color: #6BA179;
}

.claim-pending-apple {
  background-color: #6BA179;
}

.claim-pending {
  background-color: #6BA179;
}

.unclaim-pending-samsung {
  background-color: #9B8E82;
}

.unclaim-pending-android™ {
  background-color: #9B8E82;
}

.unclaim-pending-android {
  background-color: #9B8E82;
}

.unclaim-pending-apple {
  background-color: #9B8E82;
}

.unclaim-pending {
  background-color: #9B8E82;
}

.not-claimed {
  background-color: #e57200;
}

.claim-initiated {
  background-color: #e97400;
}

.ctn-number {
  color: #191919;
  margin: 10px 0;
  cursor: default;
}

.username {
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}

.wireless-col {
  width: 150px;
}

@media only screen and (max-width: 768px) {
  .btn-width {
    margin: 0;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/grouping-devices/review-group/review-group.component.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACwBZ;EA4BA;IACE,YClDE;EFCN;ECgDE;IACE,aClDE;EFIN;EC6CE;IACE,UClDE;EFON;EC0CE;IACE,aClDE;EFUN;ECuCE;IACE,aClDE;EFaN;ECoCE;IACE,UClDE;EFgBN;ECiCE;IACE,aClDE;EFmBN;EC8BE;IACE,aClDE;EFsBN;EC2BE;IACE,UClDE;EFyBN;ECwBE;IACE,aClDE;EF4BN;ECqBE;IACE,aClDE;EF+BN;ECkBE;IACE,WClDE;EFkCN;ECoBE;IACE,kBCvDE;EFqCN;ECiBE;IACE,mBCvDE;EFwCN;ECcE;IACE,gBCvDE;EF2CN;ECWE;IACE,mBCvDE;EF8CN;ECQE;IACE,mBCvDE;EFiDN;ECKE;IACE,gBCvDE;EFoDN;ECEE;IACE,mBCvDE;EFuDN;ECDE;IACE,mBCvDE;EF0DN;ECJE;IACE,gBCvDE;EF6DN;ECPE;IACE,mBCvDE;EFgEN;ECVE;IACE,mBCvDE;EFmEN;ECbE;IACE,iBCvDE;EFsEN;AACF;AC9CI;EAoCA;IACE,YC9DE;EF2EN;ECdE;IACE,aC9DE;EF8EN;ECjBE;IACE,UC9DE;EFiFN;ECpBE;IACE,aC9DE;EFoFN;ECvBE;IACE,aC9DE;EFuFN;EC1BE;IACE,UC9DE;EF0FN;EC7BE;IACE,aC9DE;EF6FN;EChCE;IACE,aC9DE;EFgGN;ECnCE;IACE,UC9DE;EFmGN;ECtCE;IACE,aC9DE;EFsGN;ECzCE;IACE,aC9DE;EFyGN;EC5CE;IACE,WC9DE;EF4GN;EC1CE;IACE,kBCnEE;EF+GN;EC7CE;IACE,mBCnEE;EFkHN;EChDE;IACE,gBCnEE;EFqHN;ECnDE;IACE,mBCnEE;EFwHN;ECtDE;IACE,mBCnEE;EF2HN;ECzDE;IACE,gBCnEE;EF8HN;EC5DE;IACE,mBCnEE;EFiIN;EC/DE;IACE,mBCnEE;EFoIN;EClEE;IACE,gBCnEE;EFuIN;ECrEE;IACE,mBCnEE;EF0IN;ECxEE;IACE,mBCnEE;EF6IN;EC3EE;IACE,iBCnEE;EFgJN;AACF;AAnJA;EACI,UAAA;EACA,gBAAA;AAqJJ;;AAnJA;EACI,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAsJJ;;AApJA;EACI;IAEI,YAAA;IACA,iBAAA;EAsJN;AACF;AAlJA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AAoJJ;AAnJI;EALJ;IAMQ,eAAA;EAsJN;AACF;;AApJA;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAuJJ;AChKI;EDKJ;IAMQ,uBAAA;EAyJN;AACF;AAxJI;EARJ;IAUc,uBAAA;EA0JZ;AACF;;AAxJA;EACI,qBAAA;EACA,iBAAA;AA2JJ;AC/KI;EDkBJ;IAIQ,kBAAA;IACA,WAAA;EA6JN;AACF;;AA3JA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AA8JJ;AC9LI;ED0BJ;IAQQ,YAAA;IACA,sBAAA;EAgKN;AACF;;AA9JA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AAiKJ;AC5MI;EDsCJ;IAOQ,WAAA;IACA,eAAA;EAmKN;AACF;;AAhKA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAmKJ;;AAhKA;EACI,YAAA;AAmKJ;;AAjKA;EACI,YAAA;AAoKJ;;AAjKA;EACI,mBAAA;EACA,gBAAA;AAoKJ;;AAjKA;EACI,YAAA;EACA,mBAAA;AAoKJ;AAnKI;EAHJ;IAIM,iBAAA;EAsKJ;AACF;;AApKA;EACI,gBAAA;EACA,WAAA;EACA,qBAAA;AAuKJ;;AApKA;EACE,YAAA;EACA,iBAAA;AAuKF;;AAnKA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AAsKF;;AAnKA;EAEE,qBAAA;EACA,sBAAA;AAqKF;;AAlKC;EACC,oBAAA;AAqKF;;AAlKA;EAEE,qBAAA;EACA,iBAAA;AAoKF;;AAjKC;EACC,yBAAA;AAoKF;;AAjKG;EAEA,yBAAA;AAmKH;;AAhKC;EAEE,yBAAA;AAkKH;;AA/JC;EAEE,yBAAA;AAiKH;;AA9JC;EACE,yBAAA;AAiKH;;AA9JC;EACE,yBAAA;AAiKH;;AA9JC;EAEE,yBAAA;AAgKH;;AA7JC;EAEE,yBAAA;AA+JH;;AA5JC;EAEC,yBAAA;AA8JF;;AA1JA;EACE,yBAAA;AA6JF;;AA1JA;EACE,yBAAA;AA6JF;;AA1JA;EACE,yBAAA;AA6JF;;AA1JA;EACE,yBAAA;AA6JF;;AA1JA;EACE,yBAAA;AA6JF;;AAzJA;EACE,yBAAA;AA4JF;;AAzJA;EACE,yBAAA;AA4JF;;AAzJA;EACE,yBAAA;AA4JF;;AAzJA;EACE,yBAAA;AA4JF;;AAzJA;EACE,yBAAA;AA4JF;;AAxJC;EACE,yBAAA;AA2JH;;AAxJC;EACE,yBAAA;AA2JH;;AAxJC;EACC,cAAA;EACA,cAAA;EACA,eAAA;AA2JF;;AAxJA;EACE,8BAAA;EACA,2BAAA;AA2JF;;AAxJA;EACE,YAAA;AA2JF;;AAvJE;EADF;IAEG,SAAA;IACA,WAAA;EA2JD;AACF","sourcesContent":["@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.step-indicator {\n    width: 80%;\n    margin-left: 10%;\n}\n.main-div {\n    margin-left: 12.25%;\n    margin-right: 12.25%;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n@media(max-width: 500px) {\n    .main-div {\n        //width: 70%;\n        width: 335px;\n        margin-left: 10px;\n        //margin-right: 10px !important;\n    }\n  }\n\n.review-heading {\n    font-size: 32px;\n    color: #000000;\n    opacity: 1;\n    float: left;\n    @media(max-width: 1024px) {\n        font-size: 24px;\n    }\n}\n.review-info {\n    width: 100%;\n    float: left;\n    margin-top: 2%;\n    margin-bottom: 2%;\n    @include respond-to('small'){\n        width: 340px !important;\n    }\n    @media only screen and\n          (max-width: 1020px) and (min-width:500px) {\n              width: 660px !important;\n       }\n}\n.review-blocks {\n    display: inline-block;\n    margin-right: 10%;\n    @include respond-to('small'){\n        margin-right: 23px;\n        width: 90px;\n    }\n}\n.review-block-heading {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n    display: inline-block;\n    width: 500px;\n    @include respond-to('small'){\n        width:325px;\n        word-break: break-word;\n    }\n}\n.review-block-value {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n    font-weight: bold;\n    @include respond-to('small'){\n        width: 95px;\n        font-size: 16px;\n    }\n}\n\n#cancel-link {\n    float: right;\n    margin-right: 20px;\n    margin-top: 15px;\n    font-size: 18px;\n}\n\n#submitGrp{\n    float: right;\n}\n.submit-section {\n    height: 50px;\n}\n\n#button-section{\n    margin-bottom: 36px;\n    margin-top: 36px;\n}\n\n.changeLink{\n    float: right;\n    margin-right: 243px;\n    @media (max-width: 1024px) {\n      margin-right: 0px;\n    }\n}\n#viewDevices{\n    margin-top: 24px;\n    width: 100%;\n    display: inline-block;\n}\n\n.continue-btn{\n  width: 171px;\n  margin-left: 19px;\n  }\n\n   \n.color-square {\n  border-radius: 2px;\n  display: inline-block;\n  height: 14px;\n  margin-right: 10px;\n  vertical-align: middle;\n  width: 14px;\n}\n\n.custumgrid-field {\n  //margin: 0 0 24px 0;\n  display: inline-block;\n  vertical-align: middle;\n }\n\n .gridText{\n  display:inline-flex\n}\n\n.custumgrid-field-status{\n  // margin: 0 0 11px 0;\n  vertical-align: super;\n  line-height: 16px;\n }\n\n .claimed-samsung {\n  background-color: #035527;\n }   \n\n   .enrolled-active {\n   //background-color: color(enrolledActive);\n   background-color: #1483D9;\n }\n\n .enrolled-not-active {\n   //background-color: color(enrolledNotActive);\n   background-color: #B9D5E8;\n }\n\n .not-enrolled {\n   //background-color: color(notEnrolled);\n   background-color: #e97400;\n }\n\n .out-of-compliance {\n   background-color: color(outOfCompliance);\n }\n\n .claimed-samsung {\n   background-color: #035527;\n }\n \n .claimed-android™ {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n\n .claimed-android {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n \n .claimed-apple {\n  // background-color: color(enrolledActive);\n  background-color: #035527;\n\n}\n\n.claim-pending-samsung{\n  background-color: #6BA179;\n\n}\n.claim-pending-android™{\n  background-color: #6BA179;\n\n}\n.claim-pending-android{\n  background-color: #6BA179;\n\n}\n.claim-pending-apple{\n  background-color: #6BA179;\n\n}\n.claim-pending{\n  background-color: #6BA179;\n\n}\n\n.unclaim-pending-samsung{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-android™{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-android{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-apple{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending{\n  background-color: #9B8E82;\n\n}\n \n .not-claimed {\n   background-color: #e57200;\n }\n\n .claim-initiated {\n   background-color: #e97400;\n }\n\n .ctn-number {\n  color: #191919;\n  margin: 10px 0;\n  cursor: default;\n}\n\n.username{\n  margin-bottom: 10px !important;\n  margin-top: 10px !important;\n}\n\n.wireless-col{\n  width: 150px;\n}\n\n.btn-width{\n  @media only screen and (max-width: 768px){\n   margin:0;\n   width:100%;\n   }\n \n }","@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
